import { colors } from '../../theme'
import { FamilyProfile } from '../../types'
import { Recipe } from '../../types/fam-graphql'

export const getRecipeChildProfile = (recipe: Recipe): FamilyProfile => {
  const steps = recipe.steps || []

  const childStep = steps.find((step) => {
    return step.family_profile !== FamilyProfile.PARENT
  })

  return (
    (childStep?.family_profile as FamilyProfile) || FamilyProfile.CHILD_SMALL
  )
}

export const getCardBackgroundColorByFamilyProfile = (
  familyProfile: FamilyProfile
) => {
  switch (familyProfile) {
    case FamilyProfile.PARENT:
      return colors.familyGrey
    default:
      return colors.familyLightBlue
  }
}

export const getTagBackgroundColorByFamilyProfile = (
  familyProfile: FamilyProfile
) => {
  switch (familyProfile) {
    case FamilyProfile.PARENT:
      return colors.familyYellow
    default:
      return colors.familyBlue
  }
}

export const getTagTextColorByFamilyProfile = (
  familyProfile: FamilyProfile
) => {
  switch (familyProfile) {
    case FamilyProfile.PARENT:
      return colors.familyBurgundy
    default:
      return colors.pureWhite
  }
}

export const getBackgroundImageByFamilyProfile = (
  familyProfile: FamilyProfile
) => {
  switch (familyProfile) {
    case FamilyProfile.PARENT:
      return '/images/family/background_fullscreen_parent.png'
    default:
      return '/images/family/background_fullscreen_children.png'
  }
}

export const getSecondaryBackgroundImageByFamilyProfile = (
  familyProfile: FamilyProfile
) => {
  switch (familyProfile) {
    case FamilyProfile.CHILD_SMALL:
      return '/images/family/secondary_image_fullscreen_steps_small.png'
    default:
      return '/images/family/secondary_image_fullscreen_steps_middle.png'
  }
}
